import { convertLrpxToRem } from '@/common/util';
import { callApp } from '../../utils';

export const userNamePattern = /@\[([^\],]+),([^\]]+)\]/g;
export const hashTagPattern = /#\[([^\],]+),([^\]]+)\]/g;

/**
 *  RN上支持复杂富文本显示，包括字体颜色、字体大小、加粗、下划线等等
 */
export const defaultHighLightArray = [
    {
        pattern: userNamePattern, // @[useName,userId]
        charStr: '@',
        matchContentIndex: 1, // 匹配到的内容的索引
        getParseResult: match => {
            return {
                text: `@${match[1]}`,
                onClick: () => {
                    // callApp();
                },
                textStyle: {
                    'font-size': convertLrpxToRem(16),
                    color: '#004182',
                    'font-weight': 700,
                },
                data: {
                    nickName: match[1],
                    userId: match[2],
                },
            };
        },
    },
    {
        pattern: hashTagPattern, // #[tagName,tagId]
        charStr: '#',
        matchContentIndex: 3, // 匹配到的内容的索引
        getParseResult: match => {
            return {
                text: `#${match[3]}`,
                onClick: () => {
                    // callApp();
                },
                textStyle: {
                    'font-size': convertLrpxToRem(16),
                    color: '#004182',
                },
                data: {
                    hashTagName: match[3],
                    hashTagId: match[5],
                },
            };
        },
    },
];
